import { render, staticRenderFns } from "./CaptureMedia.vue?vue&type=template&id=31f31eb2&scoped=true&"
import script from "./CaptureMedia.vue?vue&type=script&lang=js&"
export * from "./CaptureMedia.vue?vue&type=script&lang=js&"
import style0 from "./CaptureMedia.vue?vue&type=style&index=0&id=31f31eb2&prod&scoped=true&lang=css&"
import style1 from "./CaptureMedia.vue?vue&type=style&index=1&id=31f31eb2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f31eb2",
  null
  
)

export default component.exports